<template>
  <div style="margin-top: 1em !important">
    <div class="container">
      <h6 id="page-title">Контакты</h6>
      <div class="row">
        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_1"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Дмитрий Елькин</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">Руководитель проекта</td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">VK:</th>
                          <td class="p-1">
                            <a href="https://vk.com/kolokchik/" target="_blank"
                              >vk.com/kolokchik</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">Telegram:</th>
                          <td class="p-1">
                            <a href="https://t.me/kolokchik/" target="_blank"
                              >t.me/kolokchik</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_2"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Даниил Кочубей</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">ML-инженер</td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">VK:</th>
                          <td class="p-1">
                            <a href="https://vk.com/id177176834" target="_blank"
                              >vk.com/id177176834</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">Telegram:</th>
                          <td class="p-1">
                            <a href="https://t.me/Zimusss" target="_blank"
                              >t.me/Zimusss</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_Egor_Lishchenko"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Егор Лищенко</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">Full Stack разработчик</td>
                        </tr>
                        <!-- <tr>
                          <th scope="row" class="p-1">VK:</th>
                          <td class="p-1"><a href="https://vk.com/yahz1" target="_blank">vk.com/yahz1</a></td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">Telegram:</th>
                          <td class="p-1"><a href="https://t.me/hemishpere" target="_blank">t.me/hemishpere</a></td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_Petr_Lederer"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Пётр Ледерер</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">Программист-схемотехник</td>
                        </tr>
                        <!-- <tr>
                          <th scope="row" class="p-1">VK:</th>
                          <td class="p-1"><a href="https://vk.com/petr_lederer" target="_blank">vk.com/petr_lederer</a></td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">Telegram:</th>
                          <td class="p-1"><a href="https://t.me/frizik" target="_blank">t.me/frizik</a></td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_Alexandr_Isaev"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Александр Исаев</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">Менеджер проекта</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_Anna_Skiba"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Анна Скиба</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">UX/UI дизайнер</td>
                        </tr>
                        <!-- <tr>
                          <th scope="row" class="p-1">VK:</th>
                          <td class="p-1"><a href="https://vk.com/usagymoon" target="_blank">vk.com/usagymoon</a></td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">Telegram:</th>
                          <td class="p-1"><a href="https://t.me/t2nyt_baby" target="_blank">t.me/t2nyt_baby</a></td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_Denis_Bratusev"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Денис Братусев</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">Android-разработчик</td>
                        </tr>
                        <!-- <tr>
                          <th scope="row" class="p-1">VK:</th>
                          <td class="p-1"><a href="https://vk.com/usagymoon" target="_blank">vk.com/usagymoon</a></td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">Telegram:</th>
                          <td class="p-1"><a href="https://t.me/t2nyt_baby" target="_blank">t.me/t2nyt_baby</a></td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_Alexandr_Semenov"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Александр Семёнов</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">IOS-разработчик</td>
                        </tr>
                        <!-- <tr>
                          <th scope="row" class="p-1">VK:</th>
                          <td class="p-1"><a href="https://vk.com/usagymoon" target="_blank">vk.com/usagymoon</a></td>
                        </tr>
                        <tr>
                          <th scope="row" class="p-1">Telegram:</th>
                          <td class="p-1"><a href="https://t.me/t2nyt_baby" target="_blank">t.me/t2nyt_baby</a></td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->

        <!-- Start col -->
        <div class="col-lg-6">
          <div class="card m-b-30">
            <div class="card-body py-5">
              <div class="row">
                <div class="col-lg-3 text-center">
                  <img
                    :src="contacts_Anna_Zubkova"
                    class="img-fluid mb-3 thumb1"
                    alt="user"
                  />
                </div>
                <div class="col-lg-8">
                  <h4>Анна Зубкова</h4>
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0">
                      <tbody>
                        <tr>
                          <th scope="row" class="p-1">Должность:</th>
                          <td class="p-1">Тестировщик</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End col -->
      </div>
    </div>
  </div>
</template>
А
<script>
export default {
  name: "ContactsView",
  data: function () {
    return {
      contacts_1: require("@/assets/images/contacts/1.jpg"),
      contacts_2: require("@/assets/images/contacts/2.jpg"),
      contacts_Egor_Lishchenko: require("@/assets/images/contacts/Egor-Lishchenko.jpg"),
      contacts_Alexandr_Semenov: require("@/assets/images/contacts/Alexandr-Semenov.jpg"),
      contacts_Anna_Skiba: require("@/assets/images/contacts/Anna-Skiba.jpg"),
      contacts_Denis_Bratusev: require("@/assets/images/contacts/Denis-Bratusev.jpg"),
      contacts_Petr_Lederer: require("@/assets/images/contacts/Petr-Lederer.jpg"),
      contacts_Alexandr_Isaev: require("@/assets/images/contacts/Alexandr-Isaev.jpg"),
      contacts_Anna_Zubkova: require("@/assets/images/contacts/Anna-Zubkova.jpg"),
      contacts_anon_user: require("@/assets/images/contacts/anon_user.jpg"),
    };
  },
  mounted() {
    document.title = "Контакты | Амброзия";
  },
};
</script>

<style scoped>
#page-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  line-height: 30px;
  text-align: center;
  margin-bottom: 1.5em;
}

body {
  background: #f2f3f7;
  margin-top: 20px;
}
.m-b-30 {
  margin-bottom: 30px;
}
p {
  color: #8a98ac;
  font-family: "Inter";
  font-style: normal;
}
.table-borderless td {
  border: 0 !important;
}
.table td {
  color: #8a98ac;
  vertical-align: middle;
  border-top: 1px solid rgba(0, 0, 0, 0.03);
  padding: 0.6rem;
}
.btn-primary-rgba {
  background-color: rgba(80, 111, 228, 0.1);
  border: none;
  color: #506fe4;
}
.btn-success-rgba {
  background-color: rgba(67, 209, 135, 0.1);
  border: none;
  color: #43d187;
}
.card {
  border: none;
  border-radius: 3px;
  background-color: #ffffff;
}

.thumb1 {
  width: 103px;
  height: 103px;
  object-fit: cover;
}
</style>
